<template>
  <div
    class="place-bg"
    @click="toggleEditModeOn"
    :class="{'clickable': !editMode}"
    @mouseover="hovered = true"
    @mouseout="hovered = false"
  >
    <div
      class="place-container"
      :class="{
          'editmode': editMode
        }"
    >
      <Search
        v-if="editMode"
        ref="searcher"
        :kommunekode="'657'"
        v-on:result="this.onSearchResult"
        v-on:error="this.onSearchError"
      />
      <div
        v-else
        class="place-info"
      >{{ title }}</div>
      <edit-button
        v-if="editable "
        :onClick="this.toggleEditMode"
        :class="{'parent-hover': hovered}"
      />
    </div>
  </div>
</template>

<script>
import proj4 from 'proj4';
import * as reproject from 'reproject';
import EditButton from './EditButton.vue';
import Search from '@/components/Search/Search.vue';
export default {
  name: 'place',
  components: { EditButton, Search },
  props: {
    place: Object,
    editMode: Boolean,
    toggleEditMode: Function,
    searchResultSelected: Function,
    editable: { type: Boolean, default: true },
    placeType: String,
  },
  data: function() {
    return {
      hovered: false,
    };
  },
  computed: {
    title: function() {
      if (!this.place) {
        return `Klik for at vælge ${
          this.placeType ? this.placeType : 'sted'
        } ...`;
      }
      if (this.place.title) {
        return this.place.title;
      }
      const { postnummer } = this.place.adgangsAdresse;
      return `${this.place.adgangsAdresse.vejstykke.navn} ${
        this.place.adgangsAdresse.husnr
      }, ${postnummer.nr} ${postnummer.navn}`;
    },
  },
  methods: {
    toggleEditModeOn() {
      if (!this.editMode) {
        this.toggleEditMode();
      }
    },
    onSearchResult: function(result) {
      let coords = null;
      if (result.geometry) {
        coords = result.geometry.coordinates;
      }
      if (coords) {
        let xmin = 9999999;
        let ymin = 9999999;
        let xmax = 0;
        let ymax = 0;
        const minimumBBox = 100;
        if (result.data.vejkode) {
          // vej, dawa
          // TODO: Skal man kunne vælge vej, eller kræver vi adresse?
          // coords.forEach(element => {
          //   element.forEach(elem => {
          //     xmin = Math.min(xmin, elem[0]);
          //     ymin = Math.min(ymin, elem[1]);
          //     xmax = Math.max(xmax, elem[0]);
          //     ymax = Math.max(ymax, elem[1]);
          //   });
          // });
        } else if (coords.length === 2) {
          // adresse, dawa
          xmin = coords[0] - minimumBBox;
          ymin = coords[1] - minimumBBox;
          xmax = coords[0] + minimumBBox;
          ymax = coords[1] + minimumBBox;
        } else if (coords.length === 1) {
          // geodkobjekt
          coords[0].forEach(elem => {
            xmin = Math.min(xmin, elem[0]);
            ymin = Math.min(ymin, elem[1]);
            xmax = Math.max(xmax, elem[0]);
            ymax = Math.max(ymax, elem[1]);
          });
        }
        if (xmax > 0) {
          var centerX = (xmax + xmin) / 2;
          var centerY = (ymax + ymin) / 2;
          const epsg25832 = proj4.Proj(
            '+proj=utm +zone=32 +ellps=GRS80 +units=m +no_defs'
          );
          var wgs84center = reproject.toWgs84(
            { type: 'Point', coordinates: [centerX, centerY] },
            epsg25832
          );
          const lng = wgs84center.coordinates[0];
          const lat = wgs84center.coordinates[1];
          this.searchResultSelected({ lng, lat });
        }
      }
      this.$refs.searcher.view.blur();
    },
    onSearchError(errorObj) {
      alert('Error in searcher :(');
    },
  },
};
</script>

<style lang="scss" scoped>
.place-bg {
  background-color: $primary-700;
  border-radius: 6px;
  margin: 22px 60px 22px 80px;
  box-shadow: 0 0 15px 0 rgba(15, 28, 112, 0.1);
  position: relative;
}

.place-container {
  background-color: #f3f4fa;
  height: 76px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 0 6px 6px 0;
  margin-left: 8px;
  padding-right: 18px;
}
.editmode {
  background-color: #ffffff;
}
.place-info {
  padding: 0 35px;
  font-weight: 600;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.place-bg:before {
  content: 'A';
  background-color: $primary-700;
  color: #fff;
  position: absolute;
  top: 50%;
  margin-top: -17px;
  left: -56px;
  height: 34px;
  width: 34px;
  line-height: 34px;
  border-radius: 50%;
  text-align: center;
  font-size: 18px;
  font-weight: bold;
}

.place-bg:last-child:before {
  content: 'B';
}

.clickable {
  cursor: pointer;
}

@media only screen and (max-width: $mobile-max-width) {
  .place-bg {
    margin: 20px 30px 20px 60px;
  }

  .place-info {
    padding: 0 15px;
  }

  .place-container {
    height: 70px;
  }

  .place-bg:before {
    left: -47px;
  }
}
</style>
